import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" width="16" height="16" {...props}><path fill="#222" d="M11.33 6.67l2.52-2.02a.5.5 0 01.82.4v5.91a.5.5 0 01-.82.4l-2.52-2.03" /><path fill="#222" d="M9.33 12.67h-6c-1.33 0-2-.67-2-2V5.33c0-1.33.67-2 2-2h6c1.34 0 2 .67 2 2v5.34c0 1.33-.66 2-2 2z" opacity=".4" /></svg>);